import { purchaseRequestActionTypes } from '../actions/purchaseRequestActions';

const PurchaseRequestReducers = (state = { }, action) => {
  switch (action.type) {
  case purchaseRequestActionTypes.GET_DOWNLOAD_PURCHASE_REQUEST_DATA.LOADING: {
    const { getDownloadPRLoading } = action;
    return {
      ...state,
      getDownloadPRLoading,
    };
  }
  case purchaseRequestActionTypes.GET_PURCHASE_REQUESTS.LOADING: {
    const { getPurchaseRequestsLoading } = action;
    return {
      ...state,
      getPurchaseRequestsLoading,
    };
  }
  case purchaseRequestActionTypes.GET_PURCHASE_REQUESTS.SUCCESS: {
    const { purchaseRequests } = action;
    return {
      ...state,
      purchaseRequests,
    };
  }
  case purchaseRequestActionTypes.GET_PURCHASE_REQUEST_BY_ID.LOADING: {
    const { getPurchaseRequestByIdLoading } = action;
    return {
      ...state,
      getPurchaseRequestByIdLoading,
    };
  }
  case purchaseRequestActionTypes.GET_PURCHASE_REQUEST_BY_ID.SUCCESS: {
    const { selectedPurchaseRequest } = action;
    return {
      ...state,
      selectedPurchaseRequest,
    };
  }
  case purchaseRequestActionTypes.CREATE_PURCHASE_REQUEST.LOADING: {
    const { createPurchaseRequestLoading } = action;
    return {
      ...state,
      createPurchaseRequestLoading,
    };
  }
  case purchaseRequestActionTypes.UPDATE_PURCHASE_REQUEST.LOADING: {
    const { updatePurchaseRequestLoading } = action;
    return {
      ...state,
      updatePurchaseRequestLoading,
    };
  }
  case purchaseRequestActionTypes.UPDATE_PURCHASE_REQUEST_STATUS.LOADING: {
    const { updatePurchaseRequestStatusLoading } = action;
    return {
      ...state,
      updatePurchaseRequestStatusLoading,
    };
  }
  case purchaseRequestActionTypes.DELETE_PURCHASE_REQUEST.SUCCESS: {
    const { deletePurchaseRequestLoading } = action;
    return {
      ...state,
      deletePurchaseRequestLoading,
    };
  }
  case purchaseRequestActionTypes.GET_PURCHASE_REQUEST_SQN.LOADING: {
    const { getPrSequenceLoading } = action;
    return {
      ...state,
      getPrSequenceLoading,
    };
  }
  case purchaseRequestActionTypes.UPDATE_PR_WORKFLOW_STEP.LOADING: {
    const { updatePrWorkflowStepLoading } = action;
    return {
      ...state,
      updatePrWorkflowStepLoading,
    };
  }
  case purchaseRequestActionTypes.GET_MULTIPLE_PURCHASE_REQUESTS.LOADING: {
    const { getMultiplePurchaseRequestsLoading } = action;
    return {
      ...state,
      getMultiplePurchaseRequestsLoading,
    };
  }
  case purchaseRequestActionTypes.GET_MULTIPLE_PURCHASE_REQUESTS.SUCCESS: {
    const { multiplePurchaseRequests } = action;
    return {
      ...state,
      multiplePurchaseRequests,
    };
  }
  case purchaseRequestActionTypes.GET_PR_AVAILABILITY.LOADING: {
    const { getPrAvailabilityLoading } = action;
    return {
      ...state,
      getPrAvailabilityLoading,
    };
  }
  case purchaseRequestActionTypes.GET_PR_AVAILABILITY.SUCCESS: {
    const { prAvailability } = action;
    return {
      ...state,
      prAvailability,
    };
  }
  case purchaseRequestActionTypes.CONVERT_PR_TO_MO.LOADING: {
    const { convertPrToMoLoading } = action;
    return {
      ...state,
      convertPrToMoLoading,
    };
  }
  default: {
    return state;
  }
  }
};

export default PurchaseRequestReducers;
